import React from 'react'
import { CircularProgress, Paper, Typography } from '@material-ui/core'
import { useTranslation } from '@/langs/useTranslation'
import { FormItem } from '@/components/Form'
import { ImageUploader, TextInput } from './Compo'

const DeviceCenterTab = ({ value, onChange, loading }) => {
  const { t } = useTranslation()

  return (
    <Paper elevation={0} style={{ backgroundColor: "#F8F9FC", borderRadius: "10px", marginTop: 24 }}>
      <Typography variant="h5" style={{marginBottom: 24}}>
        2. {t({ defaultMessage: "编辑 DeviceCenter 页签" })}
        {loading && <CircularProgress size={22} style={{marginLeft: 16}} />}
      </Typography>
      <ImageUploader
        number="2.1"
        title={t({defaultMessage: "图标上传"})}
        value={value.icon}
        name="deviceCenterTab.icon"
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        number="2.2"
        title={t({defaultMessage: "文本上传"})}
        value={value.text}
        name="deviceCenterTab.text"
        placeholder={t({defaultMessage: "例：Deivce Center"})}
        onChange={onChange}
        disabled={loading}
      />
    </Paper>
  )
}

export default DeviceCenterTab